module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield"
  }, [_c('input', {
    directives: [{
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "number",
      "onfocus": "this.select()",
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.formattedValue
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.update($event)
      },
      "blur": _vm.update
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a0f4eb4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CurrencyInput.vue
// module id = 265
// module chunks = 1